<script>
import design from '@design'

export default {
  props: {
    app: {
      type: Object,
      default: () => ({}),
    },
    category: {
      type: String,
      required: true,
    },
  },
  computed: {
    isNewApp() {
      return this.app.isNewApp
    },

    appBackgroundColor() {
      if (this.isNewApp) {
        return design['secondary-orange']
      }

      const defaultColor = design['secondary-light-blue']
      const category = this.category ? this.category.toLowerCase() : ''
      const categoryColors = {
        research: design['primary-slate'],
        tools: design['secondary-green'],
        marketplace: design['secondary-red'],
        bookmarks: design['secondary-light-blue'],
      }

      return categoryColors[category] || defaultColor
    },
  },
}
</script>

<template>
  <div class="d-contents">
    <div v-if="!isNewApp" :class="$style.appTag" class="tag-text" :style="{ 'background-color': appBackgroundColor }">
      {{ category }}
    </div>
    <div v-else :class="$style.appNewTag" class="tag-text" :style="{ 'background-color': appBackgroundColor }"
      >NEW ACCESS!
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.appTag {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 22px;
  padding: 2px 16px;
  color: $white;
  border: 1px solid $white;
  border-radius: 50px;
}

.appNewTag {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 22px;
  padding: 2px 0;
  color: $white;
  border: 1px solid $white;
  border-radius: 50px;
}
</style>
